import setup from '@/redux/config/interceptors';
import { colorBackgroundBody } from '@/utils/palette';
import 'bootstrap/dist/css/bootstrap.min.css';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from 'redux-persist/integration/react';
import styled, { ThemeProvider } from 'styled-components';
import StnSetup from '../../redux/config/customHeadersApi/interceptors';
import NewRoute from './Router';
import ScrollToTop from './ScrollToTop';
import GlobalStyles from './globalStyles';
import store, { persistor } from './store';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from '@sentry/react';

const ThemeComponent = ({ children }) => {
  const { mode, direction } = useSelector((state) => ({
    mode: state?.theme?.className,
    direction: state?.rtl?.direction,
  }));

  return (
    <ThemeProvider
      theme={{
        mode,
        direction,
      }}
    >
      <GlobalStyles />
      {children}
    </ThemeProvider>
  );
};

ThemeComponent.propTypes = {
  children: PropTypes.node.isRequired,
};

const ConnectedThemeComponent = ThemeComponent;

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
      >
        <BrowserRouter>
          <ScrollToTop>
            <Fragment>
              <ConnectedThemeComponent>
                <ThemeBg>
                  <NewRoute />
                </ThemeBg>
              </ConnectedThemeComponent>
            </Fragment>
          </ScrollToTop>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

setup(store);
StnSetup(store);

export default Sentry.withProfiler(App);

const ThemeBg = styled.div`
  background: ${colorBackgroundBody};
`;
